export const DIALOGS_READY_EVENT_NAME = 'hcp-dialogs-ready';
